import React, { useState, useRef, useEffect } from 'react'
import styles from './index.module.css'
import dynamic from 'next/dynamic'
const VmsInputCheckbox = dynamic(() =>
  import('../../../vms-components/InputCheckbox').then((module) => module.VmsInputCheckbox)
)
const VmsModalPopup = dynamic(() =>
  import('../../../vms-components/ModalPopup').then((module) => module.VmsModalPopup)
)
const VmsInputRadioButton = dynamic(() =>
  import('../../../vms-components/InputRadioButton').then((module) => module.VmsInputRadioButton)
)
const VmsButton = dynamic(() =>
  import('@/components/vms-components/button').then((module) => module.VmsButton)
)

const Dropdown = ({
  id='',
  options = [],
  placeholder = 'Select option',
  variant = 'basic',
  onChange = () => {},
  additionalClassName = '',
  label = '',
  key = 'type',
  getDataByApi = false,
  onValueChange = () => {},
  isMultiSelect = false,
  showDropdownIcon = false,
  showCrossIcon = false,
  customDropdownIcon = '',
  withInput = true,
  isMobile = false,
  header = '',
  showLabel = false,
  modalCrossIcon = 'X',
  searchIcon = '',
  customInputView,
  value = [],
  footerBtnTxt = 'Done',
  showFooter = false,
  searchInputPlaceholder = 'Search...',
  autoFocus = false,
  disabled = false,
  holiday = '',
  handleClose = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const dropdownRef = useRef(null)

const filteredOptions = (variant === 'search' || variant === 'searchWithoutCheckboxWithCode' || variant === 'searchWithCheckboxWithCode') && searchTerm
  ? options.filter(option => 
      (option?.label?.toLowerCase().includes(searchTerm.toLowerCase()) ||
       option?.email?.toLowerCase().includes(searchTerm.toLowerCase()))
    )
  : options;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    setSelectedOptions(typeof value == 'object' ? value : [])
  }, [value])

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleOptionSelect = (option) => {
    let newSelectedOptions;
    if (!isMultiSelect || variant == 'radio') {
      const isSelected = selectedOptions.some((item) => item.id === option.id)
      if (isSelected && variant != 'radio') {
        newSelectedOptions = []
      } else {
        newSelectedOptions = [option]
      }
      if (!isMobile || !showFooter) setIsOpen(false)
    } else {
      const isSelected = selectedOptions.some((item) => item.id == option.id)
      if (isSelected) {
        newSelectedOptions = selectedOptions.filter((item) => item.id != option.id)
      } else {
        newSelectedOptions = [...selectedOptions, option]
      }
    }

    setSelectedOptions(newSelectedOptions)
    onChange?.(newSelectedOptions)
    setSearchTerm('')
  }

  const clearSelections = (e) => {    
    e.stopPropagation()
    setSelectedOptions([])
    onChange?.([])
  }

  const getDisplayText = () => {
    if (selectedOptions.length === 0) return placeholder

    if (variant === 'basic') {
      return selectedOptions[0].label
    }

    if (selectedOptions.length === 1) {
      return selectedOptions[0].label
    }

    return `${selectedOptions.length} items selected`
  }

  const getSearchApiCall = (value) => {
    onValueChange(value)
    setSearchTerm(value)
  }

  const ModalHeader = () => {
    return (
      <div className={styles.modal_header}>
        <div className={styles.modal_header_title}>{header}</div>
        <div
          className={styles.modal_header_close}
          onClick={() => {
            handleClose()
            setIsOpen(false)
            setSearchTerm('')
          }}
        >
          {modalCrossIcon}
        </div>
      </div>
    )
  }

  const renderDropdownOptions = () => {
    return (
      <div className={`${styles['dropdown-menu']} vms_dropdown`}>
        {(variant === 'search' || variant === 'searchWithoutCheckboxWithCode') && !getDataByApi && (
          <div className={styles['dropdown-search']}>
            <div className={styles['search-input-container']}>
              <input
              id={id}
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={styles['search-input']}
                placeholder={searchInputPlaceholder}
                onClick={(e) => e.stopPropagation()}
                autoFocus={autoFocus}
              />
              {searchIcon}
            </div>
          </div>
        )}

        {getDataByApi && (
          <div className={styles['dropdown-search']}>
            <div className={styles['search-input-container']}>
              <input
              id={id}
                type="text"
                value={searchTerm}
                onChange={(e) => getSearchApiCall(e.target.value)}
                className={styles['search-input']}
                placeholder={searchInputPlaceholder}
                onClick={(e) => e.stopPropagation()}
                autoFocus={autoFocus}
              />
              {searchIcon}
            </div>
          </div>
        )}
        <div
          className={`${styles['dropdown-options']} ${
            filteredOptions.length > 0 && filteredOptions.length * 30 < 147
              ? styles['dropdown-options-no-margin']
              : ''
          }`}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option,index) => {
              const isSelected = selectedOptions.some((item) => item.id === option.id)

              return (
                <div
                  key={index}
                  className={`${styles['dropdown-option']} ${isSelected ? styles.selected : ''}`}
                >
                  {(variant === 'checkbox' || variant === 'search') && (
                    <VmsInputCheckbox
                      boldLabelOnCheckboxSelection={false}
                      normallabel={option.label}
                      onChange={(e) => handleOptionSelect(option)}
                      value={option.label}
                      id={`${key}${option.id}`}
                      checked={isSelected}
                    />
                  )}
                  {variant === 'radio' && (
                    <VmsInputRadioButton
                      label={option.label}
                      onChange={(e) => handleOptionSelect(option)}
                      value={option.label}
                      id={`${key}${option.id}`}
                      key={`${key}${option.id}`}
                      checked={isSelected}
                    />
                  )}
                  {variant === 'searchWithCheckboxWithCode' && (
                    <VmsInputCheckbox
                      boldLabelOnCheckboxSelection={false}
                      labelComponent={
                        <div className={styles['option-container']}>
                          <span className={styles['option-value']}>{option.value}</span>
                          <span className={styles['option-label']}>{option.label}</span>
                        </div>
                      }
                      onChange={(e) => handleOptionSelect(option)}
                      value={option.label}
                      id={`${key}${option.id}`}
                      checked={isSelected}
                    />
                  )}
                  {variant === 'basic' && (
                    <span
                      className={styles['dropdown-option-label']}
                      onClick={() => handleOptionSelect(option)}
                    >
                      {option.label}
                    </span>
                  )}
                  {variant === 'searchWithoutCheckboxWithCode' && (
                    <div
                      className={styles['dropdown-option-container']}
                      onClick={() => handleOptionSelect(option)}
                    >
                      <span className={styles['dropdown-option-label']}>{option.label}</span>
                      <span className={styles['dropdown-option-code']}>{option.value}</span>
                    </div>
                  )}
                </div>
              )
            })
          ) : !searchTerm && holiday === 'holiday' ? (
            <div className={styles['dropdown-no-results']}>Please Enter Email Id or Name </div>
          ) : (
            <div className={styles['dropdown-no-results']}>{searchTerm ? 'We can’t find any results that match your search criteria.':'No result found'}</div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles['dropdown-container']} ${additionalClassName}`} ref={dropdownRef}>
      {customInputView ? (
        <div
          className={disabled ? styles['field_disabled'] : styles['dropdown-trigger']}
          onClick={toggleDropdown}
        >
          {customInputView}
        </div>
      ) : (
        <>
          {withInput ? (
            <>
              {label && showLabel && <label className={styles['dropdown-label']}>{label}</label>}
              <div
                className={`${disabled ? styles['field_disabled'] : styles['dropdown-trigger']} ${isOpen ? styles.active : ''}`}
                onClick={toggleDropdown}
              >
                <div className={styles['dropdown-selected-text']}>{getDisplayText()}</div>

                {selectedOptions.length > 0 && variant !== 'basic' && showCrossIcon && (
                  <button onClick={clearSelections} className={styles['dropdown-clear-btn']}>
                    <img
                      src="/images/cross-icon.svg"
                      alt="Clear"
                      width={16}
                      height={16}
                      className={styles['clear-icon']}
                    />
                  </button>
                )}

                {showDropdownIcon &&
                  (customDropdownIcon ? (
                    customDropdownIcon
                  ) : (
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.885002 0.114986L-2.18557e-07 0.999989L5.00001 6L10 0.999988L9.11502 0.114986L5.00001 4.23L0.885002 0.114986Z"
                        fill="black"
                      />
                    </svg>
                  ))}
              </div>
            </>
          ) : (
            <div className={styles['dropdown-label-container']} onClick={toggleDropdown}>
              {label && <label className={styles['dropdown-label']}>{label}</label>}
              {showDropdownIcon &&
                (customDropdownIcon ? (
                  customDropdownIcon
                ) : (
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.885002 0.114986L-2.18557e-07 0.999989L5.00001 6L10 0.999988L9.11502 0.114986L5.00001 4.23L0.885002 0.114986Z"
                      fill="black"
                    />
                  </svg>
                ))}
            </div>
          )}
        </>
      )}
      {!disabled && (
        <>
          {isOpen && !isMobile && renderDropdownOptions()}
          {isOpen && isMobile && (
            <VmsModalPopup
              additionalClassName={styles.mob_modal}
              isOpen={isOpen}
              contentLabel={header}
              isMobileView={isMobile}
              closeButton={true}
              onRequestClose={() => {
                setIsOpen(false)
              }}
              modalHeaderCustomView={<ModalHeader />}
              overlayClassName={styles.ax_pax_modal_overlay}
            >
              {renderDropdownOptions()}
              {showFooter && (
                <div className={styles.modal_footer}>
                  <VmsButton
                    className={styles.modal_footer_btn}
                    onClick={() => {
                      setIsOpen(false)
                      setSearchTerm('')
                    }}
                  >
                    {footerBtnTxt}
                  </VmsButton>
                </div>
              )}
            </VmsModalPopup>
          )}
        </>
      )}
    </div>
  )
}

export default Dropdown
